import React, { useState, useEffect, useRef } from "react"
import MwMonth from "../../components/Common/MwMonth"
import {
  Container,
  Row,
  Card,
  CardBody,
  Col,
  Table,
  Button,
  Modal,
  Input,
  CardSubtitle,
  CardTitle,
} from "reactstrap"
import moment from "moment"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import * as backend from "../../helpers/backend_helper"
import { accessFlags, canValidateReport } from "../../common/accessFlags"
import Toaster from "../../components/Common/Toaster"
import * as func from "../../common/functions"
import ReportValidationControls from "../../components/Common/ReportValidation"
import * as _ from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import {
  saveSatutoryReport,
  removeSaveReport,
} from "../../store/satutoryReport/action"
import ImageViewer from "../../common/ui/ImageViewer"
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import style from './index.module.css'

const StatutoryReport = (props: any) => {
  const thisMonth = moment().format("YYYY-MM")

  const [date, setDate] = useState(thisMonth)
  const [reports, setReport] = useState<any[]>([])
  const [submitedBy, setSubmitedBy] = useState<any>({})
  const [validation, setValidation] = useState<any>(null)
  const [imageViewerData, setimageViewerData] = useState<any>(null)
  const [downloading, setDownloading] = useState(false)
  // Per-document ✓/✗ validation shown inline in the table (like Daily Work).
  const [itemState, setItemState] = useState<{ [id: string]: "yes" | "no" | undefined }>({})
  useEffect(() => { setItemState((validation && validation.items) || {}) }, [validation])
  const decided = !!(validation && validation.status)
  const canValidateThis = canValidateReport(props.selectedFactory, props.user, "monthlydocument", submitedBy && submitedBy.id)
  const showItemCol = (canValidateThis && !!submitedBy.name) || decided
  const setItem = (id: string, v: "yes" | "no") =>
    setItemState((s) => ({ ...s, [id]: s[id] === v ? undefined : v }))
  const renderCheck = (id: string) => {
    const cur = itemState[id]
    if (decided) {
      if (!cur) return <span className="text-muted">—</span>
      return cur === "yes"
        ? <span style={{ color: "#1c8577", fontWeight: 800 }} title="OK">✓</span>
        : <span style={{ color: "#c0392b", fontWeight: 800 }} title="Issue">✗</span>
    }
    return (
      <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
        <button type="button" title="OK" onClick={() => setItem(id, "yes")}
          style={{ border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 9px", fontWeight: 800,
            background: cur === "yes" ? "#2ea99b" : "#eef1f4", color: cur === "yes" ? "#fff" : "#556" }}>✓</button>
        <button type="button" title="Issue" onClick={() => setItem(id, "no")}
          style={{ border: "none", borderRadius: 4, cursor: "pointer", padding: "2px 9px", fontWeight: 800,
            background: cur === "no" ? "#e07a6f" : "#eef1f4", color: cur === "no" ? "#fff" : "#556" }}>✗</button>
      </div>
    )
  }
  // PDF generated by the backend (headless Chrome) and downloaded directly.
  const downloadPdf = async () => {
    setDownloading(true)
    try {
      await backend.downloadReportPdf(
        props.selectedFactory.orgId,
        props.selectedFactory._id,
        "monthlydocument",
        date,
        `Statutory Report - ${String(date).split("-").reverse().join("")}.pdf`
      )
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Download failed")
    } finally {
      setDownloading(false)
    }
  }

  useEffect(() => {
    if (props && props.selectedFactory && props.selectedFactory.statutoryReport)
      getReport()
  }, [props && props.selectedFactory && props.selectedFactory.statutoryReport])

  // Document Review carry-forward: a document set in an earlier month persists
  // into later months until its expiry date. For any point the selected month has
  // not filled in itself, pre-fill the latest not-yet-expired value carried from a
  // previous month. Expired documents are left blank so they get renewed (and are
  // highlighted below).
  // Whether the current user may see a given document point. Admins see all.
  // A point with no assignment is visible to everyone; otherwise only to the
  // users it is assigned to.
  const canSeeDoc = (list: any) => {
    if (props.isAdmin) return true
    const assigned = list && list.assignedUsers
    if (!assigned || assigned.length === 0) return true
    return assigned.includes(props.user && props.user["_id"])
  }

  const applyCarryForward = (reportArr: any[], carryMap: any, activeDate: string) => {
    const monthStart = moment(activeDate, "YYYY-MM").startOf("month")
    return (reportArr || []).map((group: any) => ({
      ...group,
      lists: (group.lists || []).map((list: any) => {
        if (list.isHeader) return list
        const hasOwn = list.value || list.expDate || list.image
        if (hasOwn) return list
        const c = carryMap && carryMap[`${group.name}::${list.name}`]
        if (!c) return list
        const notExpired =
          !c.expDate || moment(c.expDate, "YYYY-MM-DD").isSameOrAfter(monthStart)
        if (!notExpired) return list
        return {
          ...list,
          value: c.value,
          expDate: c.expDate,
          remarks: c.remarks,
          image: c.image,
          mimeType: c.mimeType,
          carried: true,
        }
      }),
    }))
  }

  const getReport = async (newdate?) => {
    if (props.selectedFactory.statutoryReport) {
      const { orgId, _id: facId } = props.selectedFactory
      const activeDate = newdate ? newdate : date
      const template = () =>
        JSON.parse(JSON.stringify(props.selectedFactory.statutoryReport))
      try {
        const [data, carry] = await Promise.all([
          backend.getSatutoryReport(orgId, facId, activeDate),
          backend.getSatutoryReportCarry(orgId, facId, activeDate),
        ])

        let base: any[]
        if (data) {
          // Keep only template sections not already present in the saved report.
          const submittedNames = new Set((data.lists || []).map((l: any) => l.name))
          const clonedArray = template().filter(
            (cArr: any) => !submittedNames.has(cArr.name)
          )
          base = [...data.lists, ...clonedArray]
          setSubmitedBy(data.submitedBy || {})
          setValidation(data.validation || null)
        } else {
          base = template()
          setSubmitedBy({})
          setValidation(null)
        }
        // Overlay the CURRENT config's "Expiry Date" (targetTime) flag by name so
        // that toggling a document to No hides its Expiry Date column even on months
        // that already have a saved report (MW.pptx).
        const cfgTarget: any = {}
        template().forEach((g: any) =>
          (g.lists || []).forEach((l: any) => {
            cfgTarget[`${g.name}::${l.name}`] = l.targetTime
          })
        )
        base = base.map((g: any) => ({
          ...g,
          lists: (g.lists || []).map((l: any) =>
            l.isHeader ? l : { ...l, targetTime: cfgTarget[`${g.name}::${l.name}`] ?? l.targetTime }
          ),
        }))
        setReport(applyCarryForward(base, carry, activeDate))
        getLocalSaveData(activeDate)
      } catch (e) {
        // On failure, reset to the blank template for the selected month so the
        // user never unknowingly submits the previous month's answers.
        setReport(template())
        setSubmitedBy({})
        Toaster.error(typeof e === "string" ? e : "Failed to load statutory report")
      }
    }
  }

  function getLocalSaveData(currentActivedate) {
    const { _id: facId } = props.selectedFactory

    if (
      props.savedSatutoryReport[facId] &&
      props.savedSatutoryReport[facId][currentActivedate] &&
      props.savedSatutoryReport[facId][currentActivedate].date ===
      currentActivedate
    ) {
      // console.log(
      //   "prossin get saved",
      //   props.savedSatutoryReport[facId][currentActivedate]
      // )
      // setTimeList(
      //   props.dailyWorkReport.dailyWorkReportSave[facId][currentActivedate].list
      // )

      var clonedArraySave = JSON.parse(
        JSON.stringify(
          props.savedSatutoryReport[facId][currentActivedate].reports
        )
      )

      setReport(clonedArraySave)
    }
  }

  function setValue(oId, idx, e, key) {
    // console.log("oId, idx, e", oId, idx, e, reports)
    let cloneReports = [...reports]
    const list = cloneReports[oId].lists[idx]
    if (list) {
      list[key] = e
    }
    setReport([...cloneReports])
    // console.log("cloneReportscloneReports", cloneReports)
  }

  async function uploadFile(file, oId, idx, key) {
    try {
      const formData = new FormData()
      formData.append("image", file);
      let data = await backend.fileuploadAPI(formData);
      if (data.data.data && data.data.data[0]) {
        const _data = data.data.data[0];
        setValue(oId, idx, _data.id, key);
        setValue(oId, idx, _data.mimetype, 'mimeType');

      }
      console.log("uploaddata", data);
    } catch (err) {
      console.log("uploadFile", err);
    }
  }
  async function deleteFile(id) {
    try {
      let data = await backend.fileuploaddeleteAPI(id);
    } catch (err) {
      console.log("uploadFile", err);
    }
  }
  async function getFile(id) {
    return await backend.fileAPI(id);
  }


  async function submit() {
    const { orgId, _id: facId } = props.selectedFactory
    // console.log("selectedFactoryselectedFactory", props.selectedFactory)
    let data = {
      reports: reports,
      submitedBy: { name: props.user.name, id: props.user["_id"] },
    }
    try {
      await backend.saveSatutoryReport(orgId, facId, date, data)
      Toaster.success("Report Update Success")

      const removeData = {
        facId: facId,
        // reports: reports,
        // submitedBy: submitedBy,
        date: date,
      }

      props.removeSaveReport(removeData)

      getReport(date)
    } catch (e) {
      console.log("statutoryReport error", e)
      Toaster.error("Report Updated Failed")
    }
  }

  function onSaveClick() {
    // console.log("dataaaaaa", reports);
    const { _id: facId } = props.selectedFactory
    const data = {
      facId: facId,
      reports: reports,
      // submitedBy: submitedBy,
      date: date,
    }

    console.log("propssssssss", data)

    props.saveSatutoryReport(data)
    Toaster.success("Report Saved Successfully")
  }

  // console.log("reportjhsdhsbdhsj", reports)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <div style={{ width: 240 }}>
              <MwMonth
                value={date}
                onChange={(val: any) => {
                  setDate(val)
                  getReport(val)
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={4} style={{ marginLeft: "12px" }}>
              {submitedBy.name && (
                <span style={{ display: "flex" }}>
                  <h4>Submit By :</h4>{" "}
                  <p style={{ padding: "2px 4px" }} className="ml-2 mr-1">
                    {submitedBy.name}
                  </p>{" "}
                </span>
              )}
              {submitedBy.name && (
                <div style={{ marginTop: 8 }}>
                  <ReportValidationControls
                    reportType="monthlydocument"
                    dateKey={date}
                    orgId={props.selectedFactory.orgId}
                    facId={props.selectedFactory._id}
                    validation={validation}
                    isAdmin={canValidateThis}
                    submitted={!!submitedBy.name}
                    by={{ id: props.user && props.user["_id"], name: props.user && props.user.name }}
                    onChange={setValidation}
                    externalItems={itemState}
                  />
                </div>
              )}
            </Col>
          </Row>
          <div style={{ marginLeft: "12px", display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center", marginTop: "16px", marginBottom: "20px" }}>
            {reports.length > 0 && !props.readOnly && (
              <Button onClick={submit} color="success">
                Submit
              </Button>
            )}
            {submitedBy.id && (
              <Button onClick={downloadPdf} disabled={downloading} color="success">
                {downloading ? "Preparing…" : "Download PDF"}
              </Button>
            )}
            {reports.length > 0 && !props.readOnly && (
              <Button onClick={onSaveClick} color="success">
                Save
              </Button>
            )}
          </div>
          {/* <Row> */}
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {reports &&
              reports.map((report, oId) => {
                let addFiles = {}
                // var zip = new JSZip();
                // var zipfolder = zip.folder(report.name);
                // console.log("reporttttttttttt", report)
                let sno = 0
                // A non-admin sees only documents assigned to them (or documents
                // with no assignment, treated as visible to all). Admins see all.
                // Hide a whole section that has no visible document for this user.
                const hasVisible = (report.lists || []).some(
                  l => !l.isHeader && canSeeDoc(l)
                )
                if (!hasVisible) return null
                return (
                  <Col lg={12} key={oId} style={{ marginBottom: "24px" }}>
                    <Card style={{ height: "100%" }}>
                      <CardBody>
                        <CardTitle
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {report.name}
                        </CardTitle>
                        <div className="table-responsive">
                          <Table className="table table-bordered mb-0">
                            <thead>
                              <tr>
                                <th>S#</th>
                                <th>Description</th>
                                <th>Status</th>
                                <th>Exp Date</th>
                                <th>Remarks</th>
                                <th>Documents</th>
                                {showItemCol && <th>Check</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {report.lists.map((list, idx) => {
                                // Skip documents this user is not assigned to
                                // (indices are preserved so edits still map back
                                // to the correct item in `reports`).
                                if (!list.isHeader && !canSeeDoc(list)) {
                                  return null
                                }
                                if (!list.isHeader) {
                                  sno = sno + 1
                                }
                                // console.log("listasfkgnfsd", list)
                                let mimeType = ""
                                if (list.image) {
                                  // console.log("listimage", list.image)
                                  mimeType = list.mimeType;
                                  if(mimeType)
                                  addFiles[`${list.name}.${mimeType.split('/').pop()}`] = getFile(list.image);
                                  // mimeType = list.image.match(
                                  //   /[^:/]\w+(?=;|,)/
                                  // )[0]
                                  // const imgeSplit = list.image.split('base64,')
                                  // if (imgeSplit)
                                  //   zipfolder!.file(`${list.name}.${mimeType}`, imgeSplit[1], { base64: true });
                                }
                                // Flag documents that are already expired, or expiring within 30 days.
                                const expDateM = list && list.expDate ? moment(list.expDate, 'YYYY-MM-DD') : null
                                const isExpired = !!(expDateM && expDateM.isBefore(moment(), 'day'))
                                const isExpiringSoon = !!(expDateM && !isExpired && expDateM.isBefore(moment().add(30, 'd')))
                                const rowCls = isExpired ? style.isExpired : (isExpiringSoon ? style.isExpiringSoon : '')
                                return (
                                  <React.Fragment key={idx}>
                                    {!list.isHeader ? (
                                      <tr className={rowCls}>
                                        <th scope="row">{sno}</th>
                                        <td>{list.name}</td>
                                        {list.type === "select" ? (
                                          <React.Fragment>
                                            <td>
                                              <select
                                                onChange={e => {
                                                  setValue(
                                                    oId,
                                                    idx,
                                                    e.target.value,
                                                    "value"
                                                  )
                                                  if (e.target.value === "no") {
                                                    setValue(
                                                      oId,
                                                      idx,
                                                      "",
                                                      "image"
                                                    )
                                                  }
                                                }}
                                                value={
                                                  list.value ? list.value : ""
                                                }
                                                style={{
                                                  background:
                                                    list.value &&
                                                      list.value === "no"
                                                      ? "#e4e41a"
                                                      : "#FFFF",
                                                }}
                                                id="ddlCreditCardType"
                                                name="ddlCreditCardType"
                                                className="form-control"
                                              >
                                                <option
                                                  style={{
                                                    background: "#FFFF",
                                                  }}
                                                  value=""
                                                ></option>
                                                <option
                                                  style={{
                                                    background: "#FFFF",
                                                  }}
                                                  value="yes"
                                                >
                                                  Yes
                                                </option>
                                                <option
                                                  style={{
                                                    background: "#FFFF",
                                                  }}
                                                  value="no"
                                                >
                                                  No
                                                </option>
                                                {/* <option
                                                  style={{
                                                    background: "#FFFF",
                                                  }}
                                                  value="n/a"
                                                >
                                                  N/A
                                                </option> */}
                                              </select>
                                            </td>
                                          </React.Fragment>
                                        ) : (
                                          <td>
                                            <Input
                                              onChange={e =>
                                                setValue(
                                                  oId,
                                                  idx,
                                                  e.target.value,
                                                  "value"
                                                )
                                              }
                                              value={
                                                list.value ? list.value : ""
                                              }
                                              type="text"
                                              // className="form-control"
                                              id="ddlCreditCardType"
                                              name="ddlCreditCardType"
                                            ></Input>
                                          </td>
                                        )}
                                        <td>
                                          {/* Expiry Date is hidden for documents whose config
                                              "Expiry Date" flag is set to No (MW.pptx). */}
                                          {list.targetTime === "no" ? (
                                            <span className="text-muted">—</span>
                                          ) : (
                                          <div style={{ display: "flex", alignItems: "center" }}>
                                            <Input type="date" value={
                                              list.expDate ? list.expDate : ""
                                            } onChange={e => {
                                              setValue(
                                                oId,
                                                idx,
                                                e.target.value,
                                                "expDate"
                                              )
                                            }} className="" />
                                            {isExpired && (
                                              <span className={`${style.expBadge} ${style.expBadgeExpired}`}>Expired</span>
                                            )}
                                            {isExpiringSoon && (
                                              <span className={`${style.expBadge} ${style.expBadgeSoon}`}>Soon</span>
                                            )}
                                          </div>
                                          )}
                                        </td>
                                        <td>
                                            <Input
                                              onChange={e =>
                                                setValue(
                                                  oId,
                                                  idx,
                                                  e.target.value,
                                                  "remarks"
                                                )
                                              }
                                              value={
                                                list.remarks ? list.remarks : ""
                                              }
                                              type="text"
                                              // className="form-control"
                                              id="ddlCreditCardType"
                                              name="ddlCreditCardType"
                                            ></Input>
                                          </td>
                                        <td>
                                          {list.value === "yes" && (
                                            <div
                                              style={{ textAlign: "center" }}
                                            >
                                              {list.image ? (
                                                <div
                                                  style={{
                                                    textAlign: "center",
                                                    display: "flex",
                                                    justifyContent:
                                                      "space-around",
                                                  }}
                                                >
                                                  <div
                                                    onClick={() => {
                                                      // console.log("list.image", list.image)
                                                      setimageViewerData(
                                                        { image: list.image, mimeType: list.mimeType }
                                                      )
                                                    }}
                                                  >
                                                    {mimeType !== "application/pdf" ? (
                                                      <img
                                                        src={list.image}
                                                        alt="none"
                                                        width="50"
                                                        height="50"
                                                      ></img>
                                                    ) : (
                                                      <i
                                                        style={{
                                                          fontSize: "41px",
                                                          color: "green",
                                                        }}
                                                        className="bx bxs-file-pdf"
                                                      ></i>
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      padding: "10px 10px",
                                                    }}
                                                  >
                                                    {/* <i
                                                    className="bx bx-edit-alt"
                                                    style={{
                                                      cursor:"pointer",
                                                      paddingRight: "10px",
                                                    }}
                                                    // onClick={e => onEdit(e, list)}
                                                  ></i> */}
                                                    <i
                                                      style={{
                                                        cursor: "pointer",
                                                        color: "red",
                                                        fontSize: "21px",
                                                      }}
                                                      className="bx bx-trash-alt"
                                                      onClick={e => {
                                                        deleteFile(list.image)
                                                        setValue(
                                                          oId,
                                                          idx,
                                                          "",
                                                          "image"
                                                        )
                                                      }}
                                                    ></i>
                                                  </div>
                                                </div>
                                              ) : (
                                                <div>
                                                  <input
                                                    style={{ display: "none" }}
                                                    type="file"
                                                    accept="image/jpeg, image/png,.pdf,.doc"
                                                    className="custom-file-input"
                                                    id={`customFile-${oId}-${idx}`}
                                                    onChange={(e: any) => {
                                                      const file =
                                                        e.target.files[0]

                                                      const fsize = file.size
                                                      const files = Math.round(
                                                        fsize / 1024
                                                      )
                                                      // The size of the file.
                                                      if (files >= 4096) {
                                                        console.log("grater the 4 mb", files);

                                                        // alert(
                                                        //   "File too Big, please select a file less than 1mb"
                                                        // )
                                                        toastr.options = {
                                                          positionClass: "toast-top-right",
                                                          timeOut: 5000,
                                                          extendedTimeOut: 3000,
                                                          closeButton: true,
                                                        }
                                                        toastr.error("File too Big, please select a file less than 4 mb",)
                                                      } else {
                                                        console.log("lesss the one mb", files);
                                                        console.log(
                                                          "type134",
                                                          file,
                                                          // reader.result,
                                                          oId,
                                                          idx,
                                                          e
                                                        );
                                                        uploadFile(file, oId, idx, 'image')
                                                        // encode the file using the FileReader API
                                                        // const reader = new FileReader()
                                                        // reader.onloadend = () => {
                                                        //   // log to console
                                                        //   // logs data:<type>;base64,wL2dvYWwgbW9yZ...
                                                        //   setValue(
                                                        //     oId,
                                                        //     idx,
                                                        //     reader.result,
                                                        //     "image"
                                                        //   )
                                                        // }
                                                        // reader.readAsDataURL(
                                                        //   file
                                                        // )
                                                        // setformModal_data({
                                                        //   ...formModal_data,
                                                        //   file: event.target.files,
                                                        // })
                                                      }
                                                    }}
                                                  />

                                                  <label
                                                    // className="custom-file-label"
                                                    style={{
                                                      border: "1px solid",
                                                      padding: "6px",
                                                      borderRadius: "5px",
                                                    }}
                                                    htmlFor={`customFile-${oId}-${idx}`}
                                                  >
                                                    Choose file
                                                  </label>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </td>
                                        {showItemCol && (
                                          <td style={{ verticalAlign: "middle" }}>{renderCheck(list.name)}</td>
                                        )}
                                      </tr>
                                    ) : (
                                      <tr
                                        className="table-info"
                                        style={{ textAlign: "center" }}
                                      >
                                        <th colSpan={12 + 1} scope="row">
                                          {list.name}
                                        </th>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                )
                              })}
                            </tbody>
                          </Table>
                        </div>
                        <button onClick={() => {
                          const keys = Object.keys(addFiles)
                          Promise.all(Object.values(addFiles)).then((files) => {
                            var zip = new JSZip();
                            var zipfolder = zip.folder(report.name);
                            files.forEach((file: any, index) => {
                              zipfolder!.file(keys[index], file.data, { base64: false });
                            })
                            zipfolder!.generateAsync({ type: "blob" }).then(function (content) {
                              // see FileSaver.js
                              saveAs(content, report.name);
                            });
                          })

                        }} style={{ marginTop: 10 }} className="btn btn-primary">Download</button>
                      </CardBody>
                    </Card>
                  </Col>
                )
              })}
            {imageViewerData && (
              <ImageViewer
                filedata={imageViewerData}
                close={() => {
                  setimageViewerData("")
                }}
              />
            )}
            {/* </Row> */}
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

// export default

const mapStateToProps = (state, props) => {
  // console.log("state.factory", state.factory, state)

  const { user } = state.user
  const { selected: selectedFactory } = state.factory
  const _flags = accessFlags(selectedFactory)
  return {
    selectedFactory,
    user,
    ..._flags,
    factories: state.factory.factories,
    savedSatutoryReport: state.satutoryReport.saveSatutoryReport,
  }
}
StatutoryReport.displayName = "StatutoryReport"

export default withRouter(
  connect(mapStateToProps, {
    saveSatutoryReport,
    removeSaveReport,
  })(StatutoryReport)
)
